import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import StandAlonePurchaseSaleBlockData from '../../../Models/Content/StandAlonePurchaseSaleBlockData';
import StandAlonePurchaseSale from './StandAlonePurchaseSale';

export default class StandAlonePurchaseSaleBlock extends EpiComponent<StandAlonePurchaseSaleBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <StandAlonePurchaseSale iContent={this.props.data} context={this.getContext()} />  
  }
}
